export enum ContentProblem {
  EXPIRED = "expired",
  FAKE = "fake",
  INACCURATE = "inaccurate",
  OFFENSIVE = "offensive",
  ADVERTISEMENT = "advertisement",
  TECHNICAL_ISSUE = "technical_issue",
  PHOTO = "photo",
  OTHER = "other",
}
